/** Word limit for event description preview on the News & Calendar list. */
export const EVENT_CARD_PREVIEW_MAX_WORDS = 40;

export function eventId(item) {
  return item?.id ?? item?._id;
}

/**
 * Split description into a word-limited preview for list cards.
 * @returns {{ preview: string; isTruncated: boolean }}
 */
export function eventDescriptionPreview(text, maxWords = EVENT_CARD_PREVIEW_MAX_WORDS) {
  const s = typeof text === 'string' ? text.trim() : '';
  if (!s) return { preview: '', isTruncated: false };
  const words = s.split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) return { preview: s, isTruncated: false };
  return { preview: words.slice(0, maxWords).join(' '), isTruncated: true };
}

export function eventDescription(item) {
  if (!item || typeof item !== 'object') return '';
  const t = item.description ?? item.content ?? item.message ?? item.body ?? '';
  return typeof t === 'string' ? t : '';
}

/**
 * GET list/detail often returns event_date as ISO (e.g. 2026-04-11T00:00:00.000Z); POST/PATCH use YYYY-MM-DD.
 */
export function extractEventDateOnly(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') {
    const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    return '';
  }
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

export function eventDateInputValue(item) {
  return extractEventDateOnly(
    item?.event_date ?? item?.eventDate ?? item?.start_date ?? item?.startDate
  );
}

export function formatEventDateShort(isoDate) {
  const v = extractEventDateOnly(isoDate);
  if (!v) return '—';
  const [y, m, d] = v.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Month abbreviation and day for calendar-style cards (local calendar date from event). */
export function formatEventCardMonthDay(item) {
  const ymd = eventDateInputValue(item);
  if (!ymd) return { month: '—', day: '—' };
  const [y, m, d] = ymd.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return { month: '—', day: '—' };
  return {
    month: date.toLocaleDateString('en-US', { month: 'short' }),
    day: String(d),
  };
}

export function todayLocalISODate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
